import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledText = styled.p`
    font-family: ${props => `${props.fontFamily}`};
    font-size: ${props => props.fontFamily === 'MiniCorsiva' ? '16px' : '24px'};
    height:  40px;
    line-height: 40px;
`;

const FontBlockButton = ({
    background,
    fontFamily,
}) => {

    return (
        <div
            className={`b-rit-block-button block-button-theme--fonts`}
            style={{ background }}
        >
            <StyledText fontFamily={fontFamily}>
                ABC
            </StyledText>

        </div>
    );
}

FontBlockButton.propTypes = {
    background: PropTypes.object,
    fontFamily: PropTypes.string,
    displayName: PropTypes.string,

}

export default FontBlockButton;